/**
 * Constantes del módulo IngresarAgendarCitaMedica.
 * Centraliza literales mágicos para facilitar mantenimiento y reutilización.
 */

/**
 * Ancho mínimo (en px) que se considera dispositivo desktop.
 */
export const DESKTOP_BREAKPOINT = 770;

/**
 * Verifica si el dispositivo actual es desktop.
 * @returns {boolean}
 */
export const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

/**
 * Códigos CUPS que identifican la selección de médico personal/tratante.
 */
export const PERSONAL_DOCTOR_CODES = ['890201', '890283', '890263'];

/**
 * Verifica si un código CUPS corresponde al médico personal.
 * @param {string} code - Código CUPS a verificar.
 * @returns {boolean}
 */
export const isPersonalDoctorCode = (code) => PERSONAL_DOCTOR_CODES.includes(code);

/**
 * Proxy del backend de servicios.
 */
export const SERVICE_PROXY = 'ServicioTransar.svc';

/**
 * Endpoints de los servicios utilizados en el módulo.
 */
export const ENDPOINTS = {
  CHECK_ACCESS: 'CheckUserAppointmentsAccessAPI',
  GET_AFFILIATES: 'GetContributorWithMinorBeneficiariesAPI',
  GET_PBS_BRANCH: 'GetPBSBranchCode',
  GET_SPECIALTIES: 'GetAllowedScheduleMedicalServicesAPI',
  CHECK_EXTERNAL_BRANCH: 'UserHasAssignedExternalBranch',
  SEARCH_APPOINTMENTS: 'Get_Orq_ConsultaDisponibilidadAgendaAPI',
  APPOINTMENTS_CHECKER_V1: 'GetAppointmentsCheckerAPIV1',
};

/**
 * Identificadores de programas de afiliación.
 */
export const PROGRAM_GROUPS = {
  PA: 'PA',
  PC: 'PC',
  PBS: 'PBS',
};
